export default "__VITE_ASSET__B1j625p$__"